import moment from 'moment'

export function formatDate(date) {
    if (!date) {
        return null
    }
    return moment(date).format('DD-MM-YY HH:mm:ss')
}
